module.exports = __webpack_public_path__ + "img/0860-plus-circle-blue.afc1e078.svg";